import React from 'react';
import Page from "components/Page";
import AppCard from "components/AppCard";
import {useOperator} from "context/OperatorContext";
import {useQuery} from "react-query";
import ngage from "services/ngage";
import AppPlaceholder from "components/AppPlaceholder";
import AppStatus from "types/AppStatus";

function ViewAudienceApp() {
    const {operator} = useOperator()

    const {data: apps, isLoading} = useQuery(
        "apps.all",
        () => ngage.apps.all({include: 'qr-code'})
    )

    // Prepare breadcrumbs
    const breadcrumbs = {"Engagement": "/", "App Stores": "/audience-app"}

    return (
        <Page
          title="App Stores"
          subTitle='Marketing assets for promoting your app'
          breadcrumbs={breadcrumbs}
          isLoading={isLoading}
        >
            <section className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-4">
                {(operator && apps) &&
                  <>
                    {apps.data.map(app => (
                        app.status === AppStatus.PUBLISHED ?
                            <AppCard operator={operator} app={app} key={app.id}/> :
                            <AppPlaceholder platform={app.platform} status={app.status} key={app.id} />
                    ))}
                  </>
                }
            </section>
        </Page>
    );
}

export default ViewAudienceApp;